module.exports = __webpack_public_path__ + "static/media/security-badge.2b1f93a6.svg";